/** Day keys must be the athlete's LOCAL calendar date. `toISOString()`
    gives the UTC date, which rolls to "tomorrow" at 8pm US-Eastern — that
    re-triggered the morning check-in and orphaned the day's stored plan
    every evening. */
export const toLocalDayKey = (d: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** Local yyyy-mm-dd, offset by whole days from now. */
export const localDate = (offsetDays = 0): string =>
  toLocalDayKey(new Date(Date.now() + offsetDays * 86400000));
